import styled, { css } from 'styled-components';
import { CurrentUserInfo } from 'src/common/components/CurrentUserInfo';
import { media } from 'src/config/breakpoints';

export const UserProfileUserInfo = styled(CurrentUserInfo)`
  position: absolute;
  right: 1.5rem;
  top: 3.125rem;

  ${media.w.max.px992(css`
    display: none;
  `)};

  ${media.w.min.px1200(css`
    left: 70%;
    right: auto;
  `)};
`;
